var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row"},[_c('Invoice',{staticClass:"mr-3",attrs:{"year":_vm.year}}),_c('BizOrder',{staticClass:"mr-3"}),_c('EventOrder',{staticClass:"mr-3",attrs:{"year":_vm.year}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }